<template>
  <v-row>
    <v-col cols="2">
      <v-chip-group active-class="primary--text" column>
        <draggable
          v-model="elements"
          :options="availableItemOptions"
          :clone="add"
        >
          <v-chip v-for="(el, key) in elements" :key="key">
            {{ el }}
          </v-chip>
        </draggable>
      </v-chip-group>
    </v-col>
    <v-col cols="10">
      <v-row>
        <v-col cols="12">
          <v-tabs v-model="languageId">
            <v-spacer></v-spacer>
            <v-tab v-for="(language, index) in languages" :key="language.id">
              <slot name="title" :index="index" :language="language">
                <span>
                  {{ language.name }}
                </span>
              </slot>
            </v-tab>

            <v-tabs-items v-model="languageId">
              <v-tab-item
                v-for="(language, index) in languages"
                :key="language.id"
              >
                <v-row>
                  <v-col cols="12">
                    <div class="wrapper">
                      <p v-if="!form.length" class="title">
                        {{ $t('FORM_BUILDER.DROP_ELEMENTS') }}
                      </p>
                      <draggable
                        v-model="form"
                        v-bind="dragOptions"
                        class="draggable-group"
                        @change="handleChange($event)"
                      >
                        <div v-for="(el, key) in form" :key="key" draggable>
                          <v-card flat dense>
                            <v-card-title class="py-0">
                              <v-spacer></v-spacer>
                              <v-btn icon @click="edit(key, el)">
                                <v-icon>mdi-square-edit-outline</v-icon>
                              </v-btn>

                              <v-btn icon @click="remove(key)">
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </v-card-title>
                            <v-card-text>
                              <component
                                :is="fieldName(el.type)"
                                :name="
                                  el.translations.find(
                                    item => item.language_id === language.id
                                  ).name
                                "
                                :items="
                                  (el.items || []).map(item =>
                                    item.translations.find(
                                      subitem =>
                                        subitem.language_id === language.id
                                    )
                                  )
                                "
                                disabled
                              ></component>
                            </v-card-text>
                          </v-card>
                        </div>
                      </draggable>
                    </div>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import draggable from 'vuedraggable';
import formComponents from '@/modules/form_builder/components/mixins/form-components';
import defaultItem from '@/modules/form_builder/components/mixins/default-item';
import { cloneDeep } from 'lodash';
import { isEqual } from 'lodash';

export default {
  name: 'DraggableForm',

  components: {
    draggable
  },

  mixins: [formComponents, defaultItem],

  props: {
    languages: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    form: [],
    languageId: null,
    availableItemOptions: {
      group: {
        name: 'group',
        pull: 'clone',
        put: false
      },
      sort: false
    }
  }),

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'group',
        disabled: false,
        ghostClass: 'ghost',
        sort: true
      };
    }
  },

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: 'valueWatchHandler'
    }
  },

  methods: {
    valueWatchHandler(formProps) {
      if (isEqual(formProps, this.form)) {
        return;
      }

      this.form = cloneDeep(formProps);

      this.emitter();
    },

    handleChange(event) {
      if (event.added) {
        this.$emit('add', {
          key: event.added.newIndex,
          el: event.added.element
        });
      }

      this.emitter();
    },

    emitter() {
      this.$emit('input', cloneDeep(this.form));
    },

    add(type) {
      return this.getItem(type);
    },
    remove(idx) {
      this.form.splice(idx, 1);
      this.emitter();
    },
    edit(key, el) {
      this.$emit('edit', { key: key, el: el });
    }
  }
};
</script>

<style scoped>
.draggable-group {
  border: thin solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 1em;
}

.draggable-group:empty {
  padding: 2rem;
  text-align: center;
}

.wrapper {
  position: relative;
  min-height: 3em;
}

.title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
